<div class="container-fluid whatsapp-api-section py-5">
  <div class="row align-items-center">
    <!-- Left Content -->
    <div class="col-lg-6 mb-4 mb-lg-0">
      <div class="content">
        <div class="title-line"></div>
        <h1>WhatsApp Business API Connect, Engage, and Grow at Scale</h1>
        <p>
          Deliver official WhatsApp messages with verified templates, bulk
          campaigns, and real-time customer support  all powered by
          enterprise-grade security.
        </p>

        <!-- CTA Buttons -->
        <div class="mt-4 d-flex flex-wrap gap-3">
          <a class="btn btn-outline-primary" routerLink="/contact" href="/contact"> Send Your Query </a>

          <a routerLink="/signup" href="/signup" aria-label="Sign Up" class="btn btn-primary">Sign Up</a>
        </div>
      </div>
    </div>

    <!-- Right Image -->
    <div class="col-lg-6 text-center">
      <img
        src="assets/images/whatsapp-apis/whatsapp-illustration.webp"
        width="500"
        alt="WhatsApp Business API"
        class="img-fluid illustration"
        loading="lazy"
      />
    </div>
  </div>
</div>

<!-- Why Business -->
<div class="container-fluid whatsapp-features-section" id="features">
  <h2 class="mb-5">Why Businesses Around the World Choose WhatsApp API</h2>

  <div class="row g-4 mx-lg-5 px-lg-4">
    <!-- Card 1 -->
    <div class="col-md-6 col-lg-3">
      <div class="feature-card text-center">
        <div class="icon mb-3"><i class="bi bi-people"></i></div>
        <h5>Massive Reach</h5>
        <p>2.7B+ WhatsApp users worldwide.</p>
      </div>
    </div>

    <!-- Card 2 -->
    <div class="col-md-6 col-lg-3">
      <div class="feature-card text-center">
        <div class="icon mb-3"><i class="bi bi-chat-dots"></i></div>
        <h5>Higher Engagement</h5>
        <p>Higher open and response rates compared to SMS and email.</p>
      </div>
    </div>

    <!-- Card 3 -->
    <div class="col-md-6 col-lg-3">
      <div class="feature-card text-center">
        <div class="icon mb-3"><i class="bi bi-shield-check"></i></div>
        <h5>Trusted Brand Messaging</h5>
        <p>Verified business profiles build trust.</p>
      </div>
    </div>

    <!-- Card 4 -->
    <div class="col-md-6 col-lg-3">
      <div class="feature-card text-center">
        <div class="icon mb-3"><i class="bi bi-globe"></i></div>
        <h5>Supports Multiple Languages</h5>
        <p>Send messages in Hindi, English and more.</p>
      </div>
    </div>
  </div>
</div>

<!-- Why Maltech -->
<div class="why-maltech container">
  <div class="row">
    <div class="col-12 text-center mb-3">
      <h2 class="section-heading">Why Maltech</h2>
    </div>
  </div>

  <div class="row g-4 mx-lg-3 px-lg-2">
    <div class="col-12 col-sm-6 col-lg-4" *ngFor="let item of features">
      <div class="feature-card text-center">
        <!-- Icon -->
        <div class="icon-wrapper">
          <i [class]="item.icon"></i>
        </div>
        <!-- Title + Description -->
        <h5>{{ item.title }}</h5>
        <p>{{ item.desc }}</p>
      </div>
    </div>
  </div>
</div>

<!-- Right plan-->
<!-- 
<div class="pricing container" id="plans">
  <div class="row">
    <div class="col-12 text-center mb-4">
      <h2 class="section-heading">Choose the Right Plan for Your Business</h2>
    </div>
  </div>


  <div class="currency-toggle mb-5 d-flex justify-content-center">
    <button
      class="currency-btn"
      [class.active]="selectedCurrency === 'USD'"
      (click)="selectedCurrency = 'USD'"
    >
      USD
    </button>
    <button
      class="currency-btn"
      [class.active]="selectedCurrency === 'INR'"
      (click)="selectedCurrency = 'INR'"
    >
      INR
    </button>
  </div>


  <div class="row g-4 justify-content-center">
    <div class="col-md-4" *ngFor="let plan of plans[selectedCurrency]">
      <div class="pricing-card text-center" [class.popular]="plan.popular">
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="plan-name">{{ plan.name }}</h5>
          <span *ngIf="plan.popular" class="badge-popular">Most Popular</span>
        </div>
        <h2 class="plan-price">
          {{ plan.price }}
          <small>/ month</small>
        </h2>
        <button class="btn-get-started">Get Started</button>
        <ul class="plan-features list-unstyled mt-3">
          <li *ngFor="let f of plan.features">
            <i class="bi bi-check2"></i> {{ f }}
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 text-center mt-4">
      <p class="small text-muted">Enterprise plans available on request.</p>
    </div>
  </div>
</div> -->

<!-- Our Approach -->
<div class="container-fluid approach-section py-5">
  <div class="row justify-content-center">
    <div class="col-12 text-center mb-4">
      <h2 class="section-title">Our Approach to Seamless Messaging</h2>
      <p class="intro">
        We ensure every step of your messaging journey is smooth  from
        consultation to deployment and beyond.
      </p>
    </div>
  </div>

  <div class="row justify-content-center">
    <div class="col-md-8">
      <div class="timeline">
        <div
          class="timeline-step"
          *ngFor="let step of approach; let i = index"
          (mouseenter)="setActive(i)"
          (mouseleave)="clearActive()"
        >
          <!-- Icon wrapper -->
          <div class="icon-wrapper" [class.active]="i <= activeIndex">
            <i class="bi" [ngClass]="step.icon"></i>
          </div>

          <!-- Content -->
          <div class="content">
            <h5>{{ step.title }}</h5>
            <p>{{ step.desc }}</p>
          </div>

          <!-- Line connector -->
          <div class="line" [class.active]="i <= activeIndex"></div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- 24/7 and CTA -->
<div class="container-fluid support-section">
  <div class="row justify-content-center">
    <div class="col-12 text-center mb-4">
      <h2 class="section-title">24/7 Expert Support</h2>
      <p class="intro">
        Our team is available around the clock to ensure your emails are always
        delivered without issues.
      </p>
    </div>
  </div>

  <div class="row justify-content-center g-3">
    <div class="col-md-3 col-sm-6" *ngFor="let support of supports">
      <a
        [href]="support.link"
        [target]="support.newTab ? '_blank' : '_self'"
        rel="noopener noreferrer"
        class="text-decoration-none"
      >
        <div class="support-card text-center">
          <i class="bi" [ngClass]="support.icon"></i>
          <h6>{{ support.title }}</h6>
        </div>
      </a>
    </div>
  </div>
</div>

<!-- CTA Section -->
<div class="container-fluid cta-section py-5 px-4 text-center">
  <h2 class="cta-title">
    Ready to Scale Your Business on <span>WhatsApp?</span>
  </h2>
  <p class="cta-text">
    Ready to integrate WhatsApp API into your business? MALtech helps you get
    started with setup, templates, automation, and real-time monitoring.
  </p>
  <a
    [routerLink]="['/contact']"
    [href]="['/contact']"
    class="btn btn-outline-primary1 btn-lg text-decoration-none"
    rel="noopener noreferrer"
    aria-label="Contact Us"
  >
    Contact Us
  </a>
</div>
